import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type MyInfoModuleSpecsFragment } from '../../../../api/fragments/MyInfoModuleSpecs';
import ResponsiveStyledTable from '../../../shared/ResponsiveStyledTable';
import MyInfoSettingActions from './MyInfoSettingActions';

export type MyInfoSettingsTableProps = {
    module: MyInfoModuleSpecsFragment;
};

export type MyInfoSettingSpecs = MyInfoModuleSpecsFragment['myInfoSettings'][number];

const MyInfoSettingsTable = ({ module }: MyInfoSettingsTableProps) => {
    const { t } = useTranslation(['myInfoModuleDetails']);

    const renderActions = useCallback(
        (record: MyInfoSettingSpecs) => <MyInfoSettingActions module={module} myInfoSetting={record} />,
        [module]
    );

    return (
        <ResponsiveStyledTable dataSource={module.myInfoSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('myInfoModuleDetails:myInfoSettingsTable.columns.displayName')}
            />
            <Table.Column
                key="version"
                dataIndex="version"
                title={t('myInfoModuleDetails:myInfoSettingsTable.columns.version')}
            />
            <Table.Column
                key="clientId"
                dataIndex="clientId"
                title={t('myInfoModuleDetails:myInfoSettingsTable.columns.clientId')}
            />
            <Table.Column
                key="requestPurpose"
                dataIndex="requestPurpose"
                title={t('myInfoModuleDetails:myInfoSettingsTable.columns.requestPurpose')}
            />
            <Table.Column
                key="baseUrl"
                dataIndex="baseUrl"
                title={t('myInfoModuleDetails:myInfoSettingsTable.columns.baseUrl')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('myInfoModuleDetails:myInfoSettingsTable.columns.actions')}
                width={100}
            />
        </ResponsiveStyledTable>
    );
};

export default MyInfoSettingsTable;
